import React from "react";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import { Card, Table, Input, Space, Select, DatePicker, Empty, Button, Row, Col } from "antd";
import { CopyTextToClipboard } from "../../helpers/copy";
import { withTranslation } from "react-i18next";
import { removeSlashesFromPath } from "../../helpers/location/removeSlashesFromPath";
import { getRandomuserParams, scrollToAntSpinContainer, showToast, } from "../../utils";
import AppContext from "../../components/AppContext";
import { FormatTimeAgo } from "../../helpers/formatTimeAgo";
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  FilterOutlined,
  CloseOutlined,
  QuestionCircleOutlined,
  SearchOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import { getRowClassName } from "../../helpers/getRowClassName";
import Apiauth from "../../api/Apiauth";
import debounce from "lodash.debounce";
import { ColumnsVerifyCustomer } from "../../components/Columns/columns-verify-customer";
import { t } from "i18next";
import moment from "moment";
import UpdateDataByRoute from "../../helpers/isUpdateDataByRoute";
import i18next from "i18next";
import localeTH from "antd/es/date-picker/locale/th_TH";
import localeEN from "antd/es/date-picker/locale/en_US";
import dayjs from "dayjs";
import { FooterVerifyCustomer } from "../../components/Footer";

const { RangePicker } = DatePicker;
const tagsBageStatus = (status) => {
  switch (status) {
    case "SUCCESS":
    case "success":
      return "rgb(82, 196, 26)";
    case "PENDING":
    case "PROCESSING":
      return "#faad14";
    case "FAILED":
    case "not_found":
    case "REJECTED":
      return "rgb(245, 34, 45)";
    default:
      return "default";
  }
};
const tagsBageIcon = (status) => {
  switch (status) {
    case "success":
    case "SUCCESS":
      return <CheckCircleOutlined />;
    case "PENDING":
      return <ExclamationCircleOutlined />;
    case "not_found":
    case "REJECTED":
    case "FAILED":
      return <CloseOutlined />;
    default:
      return <QuestionCircleOutlined />;
  }
};

class VerifyCustomer extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      activeTabKey1: "tab1",
      dropdownPlacement: "bottomRight",
      currentLang: props.i18n.language,
      isLoad: false,
      expanded: false,
      dataTable: [],
      search: "",
      typeSearch: "account_number",
      tableParams: {
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        filters: {
          startDate: null,
          endDate: null,
        },
        sortField: null,
        sortOrder: null,
      },
    };
    this.fetchData = this.fetchData.bind(this);
    this.debouncedFetch = debounce(this.fetchData, 300);
    this.tableRef = React.createRef();
    this.onUpdateAuto = this.onUpdateAuto.bind(this);

  }
  // --- Lifecycle Methods ---
  componentDidMount() {
    this.setLoading(true);
    this.debouncedFetch();
    window.scrollTo(0, 0);
    window.addEventListener("scroll", this.handleScroll);
    this.props.i18n.on("languageChanged", this.handleLanguageChange);
    if (this.context.setFetchVerifyMemberCallback) this.context.setFetchVerifyMemberCallback(this.handleReload);
  }
  handleReload = () => this.setState({ isLoad: true }, async () => await Promise.all([this.debouncedFetch()]));

  setLoading = (_loading) => this.setState({ isLoad: _loading });
  handleScroll = () => {
    const tableElement = this.tableRef.current;
    if (tableElement) {
      const isAtBottom = tableElement.getBoundingClientRect().bottom <= window.innerHeight;

      this.setState({ dropdownPlacement: isAtBottom ? "topLeft" : "bottomRight", });
    }
  };
  componentWillUnmount() {
    this.props.i18n.off("languageChanged", this.handleLanguageChange);
    this.debouncedFetch.cancel();
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleLanguageChange = (lng) => this.setState({ currentLang: lng });

  fetchData = async () => {
    const { tableParams } = this.state;
    const { handleCheckError, setCountVerifyCustomer } = this.context;

    const params = getRandomuserParams(tableParams);
    let itemaPram = {
      limit: params.limit,
      page: params.page,
      ...tableParams.filters,
    };

    try {
      const res = await Apiauth.getDataVerifyCustomer(itemaPram);
      let total = res?.data?.count || 0;

      if (res.status === 200) {
        this.setState({ isLoad: false });

        const fetchedData = Array.isArray(res.data.data) ? res.data.data : [];
        if (typeof setCountVerifyCustomer === "function") setCountVerifyCustomer(total);

        this.setState((prevState) => ({
          dataTable: fetchedData,
          tableParams: {
            ...prevState.tableParams,
            pagination: {
              ...prevState.tableParams.pagination,
              total: total,
              current: tableParams.pagination.current,
              pageSize: tableParams.pagination.pageSize,
            },
          },
        }));
      } else {
        showToast("error", t("Failed to fetch data."));
        this.setState({ isLoad: false, dataTable: [] });
      }
    } catch (error) {
      handleCheckError(error);
      console.error("Error fetching data:", error);
      this.setState({ dataTable: [], isLoad: false });
    }
  };

  handleTableChange = (pagination, filters, sorter, extra) => {
    const sortField = Array.isArray(sorter) ? sorter[0]?.field : sorter.field;
    const sortOrder = Array.isArray(sorter) ? sorter[0]?.order : sorter.order;
    this.setState(
      (prevState) => ({
        isLoad: true,
        tableParams: {
          ...prevState.tableParams,
          pagination: {
            ...prevState.tableParams.pagination,
            current: pagination.current,
            pageSize: pagination.pageSize,
          },
          filters: prevState.tableParams.filters,
          sortField: sortField,
          sortOrder: sortOrder,
        },
      }),
      async () => {
        scrollToAntSpinContainer();
        await Promise.all([this.debouncedFetch()]);
      },
    );
  };
  onChangeTypeSearch = (value) => {
    const { search } = this.state;
    this.setState(
      (prevState) => ({
        isLoad: true,
        typeSearch: value,
        tableParams: {
          ...prevState.tableParams,
          pagination: {
            ...prevState.tableParams.pagination,
            current: 1,
          },
          filters: {
            ...prevState.tableParams.filters,
            typeSearch: value,
            search: search,
          },
        },
      }),
      async () => {
        scrollToAntSpinContainer();
        this.debouncedFetch();
      },
    );
  };
  onOk = (value) => {
    // ตรวจสอบว่ามีค่าทั้งสองวันที่หรือไม่
    const hasDates = value && value.length >= 2 && value[0] && value[1];

    const dateFilters = {
      startDate: hasDates ? value[0] : null,
      endDate: hasDates ? value[1] : null,
    };

    this.setState(
      (prevState) => ({
        isLoad: true,
        tableParams: {
          ...prevState.tableParams,
          pagination: {
            ...prevState.tableParams.pagination,
            current: 1,
          },
          filters: {
            ...prevState.tableParams.filters,
            ...dateFilters,
          },
        },
      }),
      () => {
        scrollToAntSpinContainer();
        this.debouncedFetch();
      }
    );
  };
  onChangeSearch = (value) => {
    const { typeSearch } = this.state;
    this.setState(
      (prevState) => ({
        isLoad: true,
        search: value,
        tableParams: {
          ...prevState.tableParams,
          pagination: {
            ...prevState.tableParams.pagination,
            current: 1,
          },
          filters: {
            ...prevState.tableParams.filters,
            typeSearch: typeSearch,
            search: value,
          },
        },
      }),
      async () => {
        scrollToAntSpinContainer();
        this.debouncedFetch();
      },
    );
  };
  onTab1Change = (key) => this.setState({ activeTabKey1: key });

  onUpdateAuto = async () => this.setState({ isLoad: false }, async () => await Promise.all([this.debouncedFetch()]));

  getAntdLocale = () => {
    const currentLanguage = i18next.language;
    if (currentLanguage === "th" || currentLanguage === "lao") {
      return localeTH;
    }
    return localeEN;
  };

  handleClearCache = async (acc) => {
    if (!acc) return showToast("warning", t("Please enter an account number to clear cache."));
    try {
      Apiauth.clearCacheVerifyCustomer({ accountNo: acc })
        .then((res) => {
          if (res.status === 200) {
            showToast("success", `${t("Cache cleared successfully.")} ${res.data.affected}`);
            this.handleReload();
          }
        })
        .catch((error) => {
          console.error("Error clearing cache:", error);
          showToast("error", t("Failed to clear cache."));
        });
    } catch (error) {
      showToast("error", t("Failed to clear cache."));
      console.error("Error clearing cache:", error);

    }
  }

  disabledDate = (current) => {
    if (!current) return false;

    // 1. ห้ามเลือกวันที่ในอนาคต (หลังจากวันนี้)
    const isAfterToday = current.isAfter(dayjs().endOf('day'));

    // 2. ห้ามเลือกวันที่เก่ากว่า 60 วันที่แล้ว
    const sixtyDaysAgo = dayjs().subtract(60, 'days').startOf('day');
    const isBefore60Days = current.isBefore(sixtyDaysAgo);

    return isAfterToday || isBefore60Days;
  };

  // --- Render Method ---
  render() {
    const { t } = this.props;
    const { nameMerchang, isMobile } = this.context;

    const {
      activeTabKey1,
      tableParams,
      isLoad,
      dataTable,
      typeSearch,
      search,
      expanded
    } = this.state;

    const columns = ColumnsVerifyCustomer(
      nameMerchang,
      CopyTextToClipboard,
      tagsBageStatus,
      t,
      FormatTimeAgo,
      tagsBageIcon,
      expanded
    );
    let isStartDate = tableParams.filters.startDate;
    let isEndDate = tableParams.filters.endDate;
    let isTotal = Intl.NumberFormat().format(tableParams.pagination.total);
    let isDate = isStartDate && isEndDate;
    let labelTxt = isDate ? t("verify_customer_date", { date: `${moment(isStartDate).format("YYYY-MM-DD")}-${moment(isEndDate).format("YYYY-MM-DD")}`, count: isTotal }) : t("verify_customer_today", { count: isTotal });
    const tabList = [
      {
        key: "tab1",
        tab: labelTxt,
      },
    ];
    const contentList = {
      tab1: (
        <>
          <div className="body table-responsive">
            <Table
              className="col-lg-12"
              columns={columns}
              rowKey={(record) => record.customer_uuid || record.id}
              onChange={this.handleTableChange}
              dataSource={dataTable || []}
              loading={isLoad}
              rowClassName={getRowClassName}
              locale={{
                emptyText: (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={t("No data")}
                  />
                ),
              }}
              pagination={{
                ...tableParams.pagination,
                showSizeChanger: true,
                locale: {
                  items_per_page: `/ ${t("paged")}`,
                },
                showTotal: (total, range) => {
                  // คำนวณหน้าปัจจุบัน
                  const currentPage = tableParams.pagination.current;
                  // คำนวณจำนวนหน้าทั้งหมด
                  const totalPages = Math.ceil(total / tableParams.pagination.pageSize);

                  return (
                    <span>
                      {/* แสดง: หน้า 1 จาก 10 | แสดง 1-10 จาก 100 รายการ */}
                      <strong>{t("Page", { page: Intl.NumberFormat().format(currentPage), totalPages: Intl.NumberFormat().format(totalPages) })}</strong>
                      <span style={{ marginLeft: 10 }}>
                        {t("Showing", { from: Intl.NumberFormat().format(range[0]), total: Intl.NumberFormat().format(total), of: Intl.NumberFormat().format(range[1]) })}
                      </span>
                    </span>
                  );
                },
              }}
              scroll={{ x: "max-content" }}
            />
          </div>
        </>
      ),
    };


    const options = [
      {
        value: "account_number",
        label: t("account_number"),
      },
    ];
    // ตั้งค่า Locale ภายใน Render เพื่อให้เปลี่ยนตาม i18next
    const antdLocale = this.getAntdLocale();
    const currentLanguage = i18next.language;
    dayjs.locale(currentLanguage === "lao" ? "lo" : currentLanguage);
    let isIconCalendar = (<CalendarOutlined style={{ color: "#bfbfbf" }} />)
    return (
      <>
        {/* Page Content */}
        <UpdateDataByRoute onUpdateAuto={this.onUpdateAuto} />
        <div style={{ flex: 1 }}>
          <div className="container-fluid">
            <PageHeader
              HeaderText={t("verify Customer")}
              Breadcrumb={[
                {
                  name: removeSlashesFromPath(window.location.pathname),
                  navigate: window.location.pathname,
                },
              ]}
            />
            <br className="sm-hiden" />

            <Card
              title={
                <Row gutter={isMobile ? [0, 0] : [48, 48]} justify="space-between" align="middle" wrap>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12} style={{ marginBottom: isMobile ? 15 : 0 }}>
                    <RangePicker
                      style={{ width: isMobile ? "100%" : "75%" }}
                      disabledDate={this.disabledDate}

                      prefix={isIconCalendar}
                      showTime={isMobile ? { format: "HH" } : false}
                      showNow={false}
                      locale={antdLocale}
                      format="YYYY-MM-DD"
                      placeholder={[t("StartDate"), t("EndDate")]}
                      allowClear={true}
                      onChange={(value, dateString) => this.onOk(dateString)}
                      onOk={(value) => this.onOk(value)}
                      renderExtraFooter={() => {
                        return (<><span className="d-block text-danger fs-12 fs-sm-10">* {t("transaction_history_note")}</span></>)
                      }}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12} style={{ display: "flex", justifyContent: isMobile ? "center" : "flex-end" }}>
                    <Space.Compact className={`${isMobile ? "w-100" : "w-90"}`} >
                      <Select
                        prefix={<FilterOutlined />}
                        onChange={(value) => this.onChangeTypeSearch(value)}
                        defaultValue={typeSearch}
                        value={typeSearch}
                        autoFocus={false}
                        options={options}
                      />
                      <Input
                        autoFocus={false}
                        allowClear={true}
                        size="small"
                        suffix={<SearchOutlined />}
                        placeholder={t("Search by account number")}
                        onChange={(e) => this.onChangeSearch(e.target.value)}
                        value={search}
                      />
                      <Button disabled={!search} onClick={() => this.handleClearCache(search)} className="sm-hiden-" style={{ marginLeft: 6 }}>{t("Clear Cache")}</Button>
                    </Space.Compact>
                  </Col>
                </Row>
              }
              extra={null}
              tabList={tabList}
              activeTabKey={activeTabKey1}
              onTabChange={this.onTab1Change}
            >
              {contentList[activeTabKey1]}
              {/* Footer Note */}
              <FooterVerifyCustomer t={t} />
            </Card>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = ({ mailInboxReducer }) => ({
  isInbox: mailInboxReducer.isInbox,
});

export default connect(
  mapStateToProps,
  null,
)(withTranslation()(VerifyCustomer));
